"use client";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
// TODO: !! Validate sticky={true}
// | Old props                 | New props                                       | Result                            |
// | ------------------------- | ----------------------------------------------- | --------------------------------- |
// | `sticky={true}`           | *(nothing — defaults)*                          | desktop sticky + mobile fixed     |
// | `sticky={false}`          | `stickInColumn={false} stickToViewport={false}` | just flows (no sticking anywhere) |
// | `sticky={true}`           |                                                 |                                   |
// |   `fixedOnMobile={false}` | `stickInColumn={true} stickToViewport={false}`  | desktop sticky + mobile contained |
// | *(never used)*            |                                                 |                                   |
// |   `fixedOnMobile={true}`  | `stickInColumn={false} stickToViewport={true}`  | desktop flow + mobile fixed       |
const HEADER_HEIGHT_REM = 4; // match your BaseHeader height
const FOOTER_HEIGHT_REM = 4; // match your BaseFooter height
export const MultiColumnLayoutContext = React.createContext({
    isDesktop: false,
    debug: false,
});
const MultiColumnLayout = ({ children, debug = false, constrainHeight = true, gap = "0", }) => {
    const [isDesktop, setIsDesktop] = useState(false);
    // 1) breakpoint watcher
    useEffect(() => {
        const onResize = () => setIsDesktop(window.innerWidth >= 768);
        onResize();
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);
    // 2) collect widths
    const widths = React.Children.toArray(children)
        .filter(React.isValidElement)
        .map((child) => { var _a; 
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    return (_a = child.props.width) !== null && _a !== void 0 ? _a : "1fr"; });
    const gridCols = isDesktop ? widths.join(" ") : "1fr";
    // 3) calculate available height
    const containerHeight = `calc(100vh - ${HEADER_HEIGHT_REM}rem - ${FOOTER_HEIGHT_REM}rem)`;
    // const containerHeight = `calc(100vh - ${HEADER_HEIGHT_REM}rem - 4rem)`;
    return (_jsxs(MultiColumnLayoutContext.Provider, { value: { isDesktop, debug }, children: [debug && (_jsxs("div", { className: "fixed right-0 top-0 z-30 bg-black p-2 text-xs text-white", children: [isDesktop ? "Desktop" : "Mobile", " \u2022 cols: ", gridCols] })), _jsx("div", { className: "w-full", style: Object.assign(Object.assign({ display: "grid", gridTemplateColumns: gridCols, gap }, (constrainHeight && isDesktop
                    ? { height: containerHeight, overflow: "hidden" }
                    : {})), (debug ? { border: "1px solid red" } : {})), children: children })] }));
};
const Column = ({ width = "1fr", scrollable = false, className = "bg-[#FAFAFA] dark:bg-[#1A1A22]", children, }) => {
    const { isDesktop, debug } = React.useContext(MultiColumnLayoutContext);
    // 1) flatten children into an array
    const items = React.Children.toArray(children);
    // 2) pick out StickyHeader and StickyFooter nodes
    const headerItems = items.filter((c) => React.isValidElement(c) && c.type === StickyHeader);
    const footerItems = items.filter((c) => React.isValidElement(c) && c.type === StickyFooter);
    // 3) everything else is body
    const bodyItems = items.filter((c) => !(React.isValidElement(c) &&
        (c.type === StickyHeader || c.type === StickyFooter)));
    const borderClasses = isDesktop
        ? "border-r border-[#E4E4E7] dark:border-[#4A4A52] last:border-r-0"
        : "";
    return (_jsxs("div", { 
        // bg-[#6E6E78]
        className: `relative flex h-full min-h-0 flex-col ${borderClasses} ${className}`, style: Object.assign(Object.assign({}, (debug ? { border: "1px solid pink" } : {})), { width: isDesktop ? width : "100%" }), children: [headerItems, _jsx("div", { className: scrollable && isDesktop ? "min-h-0 flex-1 overflow-y-auto" : undefined, children: bodyItems }), footerItems] }));
};
const StickyHeader = ({ height = "4rem", className = "", style, children, }) => (_jsx("div", { className: `sticky top-0 z-20 border-b border-[#E4E4E7] bg-white shadow-sm dark:border-[#4A4A52] dark:bg-[#1A1A22] ${className}`, style: Object.assign({ height }, style), children: children }));
const WizardSlot = ({ isActive, children }) => (_jsxs("div", { className: "relative", children: [!isActive && (_jsx("div", { className: "pointer-events-none absolute inset-0 bg-[#6E6E78]/60 backdrop-blur dark:bg-[#1A1A22]/60" })), _jsx("div", { className: !isActive ? "opacity-80" : undefined, children: children })] }));
const StickyFooter = ({ children, 
// sticky = true,
stickInColumn = true, stickToViewport = true, className = "", style, }) => {
    const { isDesktop } = React.useContext(MultiColumnLayoutContext);
    // on mobile → fixed to viewport bottom; on desktop → sticky in the grid
    const positionClasses = isDesktop
        ? stickInColumn
            ? "sticky bottom-0 w-full"
            : ""
        : stickToViewport
            ? "fixed bottom-[4.2rem] w-full"
            : "absolute inset-x-0 bottom-0";
    return (_jsx("div", { className: `${positionClasses} z-20 border-t border-[#E4E4E7] bg-transparent dark:border-[#4A4A52] ${className}`, style: style, children: children }));
};
MultiColumnLayout.Column = Column;
MultiColumnLayout.StickyHeader = StickyHeader;
MultiColumnLayout.StickyFooter = StickyFooter;
MultiColumnLayout.WizardSlot = WizardSlot;
export default MultiColumnLayout;
